import React,{Component} from 'react';
class Foot extends Component{
    handleGotoGov = () => {
        window.location.href="https://beian.miit.gov.cn";
    };
    render(){
        return (
            <div style={{backgroundImage:'url(\''+this.props.src+'\')',backgroundSize:'cover',
                backgroundPositionX: 'center',boxShadow: '0px -10px 10px #888888',
                backgroundPositionY: 'top',height:'150px',width:'100%'}}>
                <table align="center" style={{verticalAlign:'medium',height:'100%'}}>
                    <tbody>
                    <tr><td valign="medium"><h5  style={{textShadow:'0px 0px 30px #ff5b5b',color: '#fdab9d'}}>
                        {this.props.sentence}
                    </h5>
                        <a><h5  style={{textShadow:'0px 0px 30px #ff5b5b',color: '#fbfbfb',textAlign:'center'}}>
                            {this.props.info} <span onClick={this.handleGotoGov.bind(this)} style={{color:'white',cursor:'pointer'}}>&nbsp;湘ICP备17016414号-1</span>
                        </h5></a>
                    </td></tr>
                    </tbody>
                </table>

            </div>
        )
    }

}
export default Foot;



// WEBPACK FOOTER //
// ./src/Compent/page/Foot.js